<template>
  <div>
    <Header></Header>
    <div>
      <div class="block part1" id="part1">
        <img width="100%" src="../img/index/banner.png" alt />
        <div class="part1-text">
          <p class="text-white p1"></p>
          <p class="text-white p2">诚信&nbsp;&nbsp;&nbsp;&nbsp;团队&nbsp;&nbsp;&nbsp;&nbsp;创新&nbsp;&nbsp;&nbsp;&nbsp;激情</p>
          <img src="../img/index/down-arrow.png" alt @click="slideToPart2()" />
        </div>
      </div>

      <div class="block part2 row" id="part2">
        <div class="col-sm-6">
          <div style="padding-left: 40px;">
            <p class="text-left title">及时雨小额贷款</p>
            <p class="text-left p2">上海嘉定及时雨小额贷款股份有限公司于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。</p>
            <p
              class="text-left p3"
            >公司拥有一支深耕小微金融近20年的核心团队，坚持小而分散的信贷理念，通过数字化打造小微金融的全流程智能风控系统“慧石系统”，服务于机构及小微企业客户。</p>
          </div>
        </div>
        <div class="col-sm-6">
          <img src="../img/index/intro-comp.png" alt />
        </div>
        <div class="part2-text row">
          <div class="col-sm-3 text-left">
            <p class="biggest">
              87.53<span class="bigger">亿</span>
            </p>
            <p class="subtitle">累计放贷金额</p>
          </div>
          <div class="col-sm-3 text-left">
            <p class="biggest">30290</p>
            <p class="subtitle">累计放贷笔数</p>
          </div>
          <div class="col-sm-3 text-left">
            <p class="biggest">11095</p>
            <p class="subtitle">累计放贷客户</p>
          </div>
          <div class="col-sm-3 text-left">
            <p class="biggest">
              8<span class="bigger">年</span>
            </p>
            <p class="subtitle">运营时间</p>
          </div>
        </div>
      </div>

      <div class="part3-con">
        <div class="block part3" id="part3">
          <!-- <img width="100%" src="../img/index/our-service.png" alt=""> -->
          <div class="part3">
            <div class="col-sm-6 part3-text" style="padding-left: 40px;">
              <p class="title text-left">我们的服务</p>
              <p class="subtitle text-left">无抵押、纯信用贷款，快至当天放款</p>
              <p class="desc text-left">
                <span class="s-title">过桥资金</span>
                <span class="s-desc">客户需要归还银行贷款的本金时，可在我司借款，用于结清现有银行的按揭贷款、抵押贷款等</span>
              </p>
              <p class="desc text-left">
                <span class="s-title">小微企业贷</span>
                <span class="s-desc">为小微企业提供信用贷款，解决融资难、费用贵问题</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block part4" id="part4">
        <p class="title">我们的优势</p>
        <p class="subtitle">我们的承诺很简单。没有复杂的术语，没有令人费解的费用，只是为您的未来设计简单的财务解决方案。</p>
        <div class="row cakes">
          <div class="col-sm-3 cake">
            <img src="../img/index/icon-1.png" width="80px" alt />
            <div class="cake-desc">
              <p class="main-desc">高</p>
              <p class="sub-desc">贷款额度高</p>
              <p class="sub-desc">最高可借500万</p>
            </div>
          </div>
          <div class="col-sm-3 cake">
            <img src="../img/index/icon-2.png" width="80px" alt />
            <div class="cake-desc">
              <p class="main-desc">快</p>
              <p class="sub-desc">在线审批</p>
              <p class="sub-desc">2-3天放款</p>
            </div>
          </div>
          <div class="col-sm-3 cake">
            <img src="../img/index/icon-3.png" width="80px" alt />
            <div class="cake-desc">
              <p class="main-desc">灵</p>
              <p class="sub-desc">借款期限灵活</p>
              <p class="sub-desc">1-12期任选</p>
            </div>
          </div>
          <div class="col-sm-3 cake">
            <img src="../img/index/icon-4.png" width="80px" alt />
            <div class="cake-desc">
              <p class="main-desc">易</p>
              <p class="sub-desc">免抵押</p>
              <p class="sub-desc">免担保</p>
            </div>
          </div>
        </div>
      </div>

      <div class="block part5" id="part5">
        <div class="mask">
          <i class="arrow arrow-left" @click="slide(1)">
            <img src="../img/index/arrow-left.png" alt />
          </i>
          <i class="arrow arrow-right" @click="slide(2)">
            <img src="../img/index/arrow-right.png" alt />
          </i>
          <div class="mask-content text-white" @click="toStory()">
            <!--<a :href="url">-->
            <p class="mask-title">我们的故事</p>
            <p class="mask-subtitle">了解为什么成千上万的客户选择及时雨小贷。</p>
            <p class="mask-avatar" v-show="avatar === 'pear'">
              <img width="136px" height="136px" src="../img/index/story/pear.png" alt />
            </p>
            <p class="mask-avatar" v-show="avatar === 'woman'">
              <img width="136px" height="136px" src="../img/index/story/woman.png" alt style="border-radius: 68px"/>
            </p>
            <p class="mask-avatar" v-show="avatar === 'designer'">
              <img width="136px" height="136px" src="../img/index/story/designer.png" alt />
            </p>
            <p class="mask-avatar" v-show="avatar === 'supermarket'">
              <img width="136px" height="136px" src="../img/index/story/supermar.png" alt />
            </p>
            <p class="mask-quote">{{ quote }}</p>
            <p class="mask-desc">{{ desc }}</p>
            <!--</a>-->
          </div>
        </div>

        <!--banner start-->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img width="100%" src="../img/index/story/b1.png" alt />
            </div>
            <div class="swiper-slide">
              <img width="100%" src="../img/index/story/b2.png" alt />
            </div>
            <div class="swiper-slide">
              <img width="100%" src="../img/index/story/b3.png" alt />
            </div>
            <div class="swiper-slide">
              <img width="100%" src="../img/index/story/b4.png" alt />
            </div>
          </div>
        </div>
        <!--banner end-->
      </div>

      <div class="block part6" id="part6">
        <p class="title">媒体报道</p>
        <div class="row cakes justify-content-around">
          <div class="col-sm-4">
            <a href="/#/NewsDetail?id=1">
              <div class="news-pic">
                <p class="pic-tag">最新</p>
                <div class="pic-shadow">
                  <p class="pic-title">及时雨小贷半年度工作总结</p>
                  <p class="pic-cont">7月31日，及时雨高管团队20余人，齐聚新疆乌鲁木齐，召开半年度工作会议。</p>
                </div>
              </div>
            </a>
          </div>
          <div class="col-sm-7 row">
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=9">
                <p class="news-title">及时雨小贷创始人宋梅受邀出席第七届“在沪女企业家峰会”！</p>
                <p class="news-text">3月31日，“巾帼荣耀，星闪浦江——第七届十八省在沪商会女企业家峰会”成功举行。</p>
                <p class="divide-line">——</p>
              </a>
            </div>
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=10">
                <p class="news-title">全员齐动，稳中求进——2019及时雨小贷团建</p>
                <p class="news-text">2019年10月26日，及时雨小贷团队建设活动！</p>
                <p class="divide-line">——</p>
              </a>
            </div>
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=8">
                <p class="news-title">及时雨小贷宋梅荣获“2015中国小微金融年度人物”称号</p>
                <p class="news-text">2016年4月9日， 第六届中国小微金融机构联席会年会在...</p>
                <p class="divide-line">——</p>
              </a>
            </div>
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=2">
                <p class="news-title">周年庆丨六年风雨同行 共谱美好篇章</p>
                <p class="news-text">2013年3月8日，及时雨小贷经上海市政府批准成立。时光流逝...</p>
                <p class="divide-line">——</p>
              </a>
            </div>
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=3">
                <p class="news-title">喜报！上海及时雨小贷斩获“全国优秀小贷”荣誉</p>
                <p class="news-text">未来，及时雨小贷将再接再厉，继续积极发挥优秀典型示范作用！</p>
                <p class="divide-line">——</p>
              </a>
            </div>
            <div class="col-sm-6">
              <a href="/#/NewsDetail?id=5">
                <p class="news-title">重磅：上海小贷行业完成首单同业拆借</p>
                <p class="news-text">2018年4月3日，上海小贷行业首单同业拆借签约仪式在上海嘉定及时...</p>
                <p class="divide-line">——</p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="right-banner">
        <div>
          <ul class="list-unstyled text-center">
            <li class="contact-way">
              <a href="/#/notice">
                <span class="words">
                  公司
                  <br />公告
                </span>
              </a>
            </li>
            <li class="weixin-kefu">
              <span class="words">
                快速
                <br />借款
              </span>
              <img src="../img/common/wechat-new.png" alt />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import $ from "jquery";
import Swiper from "swiper";
var swiper;
const MaskContent = [
  {
    role: "p",
    // avatar:'/img/index/story/pear.png',
    avatar: "pear",
    quote: "河北种梨人老梁的致富路",
    desc:
      "老梁，河北赵县农民，今年49岁，2005年响应政改，摇身一变赵县梨业佼佼者，种梨13年“鸭梨山大”！",
    url: "/#/CustomerDetail?id=3"
  },
  {
    role: "w",
    // avatar:'/img/index/story/woman.png',
    avatar: "woman",
    quote: "骨子里就喜欢折腾的上海女人",
    desc:
      "王颖是土生土长的上海人，从酒店贸易行业转型房车露营，追寻吉普赛人的浪漫情节！",
    url: "/#/CustomerDetail?id=1"
  },
  {
    role: "d",
    // avatar:'/img/index/story/designer.png',
    avatar: "designer",
    quote: "在中国做设计越来越有尊严",
    desc:
      "因为是设计师出身，大家都叫他“李工”，浙江人，80后，创立独立品牌，主做家具设计、空间规划。",
    url: "/#/CustomerDetail?id=2"
  },
  {
    role: "s",
    // avatar:'/img/index/story/supermar.png',
    avatar: "supermarket",
    quote: "80后超市创二代的生意经",
    desc: "开连锁超市、扩大超市经营面积，吴佟的超市越来越红火。",
    url: "/#/CustomerDetail?id=6"
  }
];

export default {
  name: "Index",
  components: { Header, Footer },
  data() {
    return {
      s: 0,
      title: MaskContent[2].title,
      subtitle: MaskContent[2].subtitle,
      avatar: MaskContent[2].avatar,
      quote: MaskContent[2].quote,
      desc: MaskContent[2].desc
    };
  },

  created() {},

  mounted() {
    let that = this;
    swiper = new Swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 0,
      paginationClickable: true,
      loop: true,
      observer: true,
      observeParents: true,
      onSlideChangeEnd: function(swiper) {
        // let s;  //0梨  1上海女人 2设计师  3超市
        if (swiper.activeIndex === 2) {
          that.s = 0;
        } else if (swiper.activeIndex === 3 || swiper.activeIndex === 7) {
          that.s = 1;
        } else if (swiper.activeIndex === 0 || swiper.activeIndex === 4) {
          that.s = 2;
        } else if (swiper.activeIndex === 5) {
          that.s = 3;
        }
        that.avatar = MaskContent[that.s].avatar;
        that.quote = MaskContent[that.s].quote;
        that.desc = MaskContent[that.s].desc;
      }
    });
    // setTimeout(function() {$('.mask').height($('#part5').height());},500);
  },

  methods: {
    slideToPart2: function() {
      $("html,body").animate(
        {
          scrollTop: $("#part2").offset().top
        },
        500
      );
    },

    slide: function(d) {
      if (d === 1) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    },

    toStory: function() {
      let k = this.s;
      switch (k) {
        case 0:
          window.location.href = "/#/CustomerDetail?id=3";
          break;
        case 1:
          window.location.href = "/#/CustomerDetail?id=1";
          break;
        case 2:
          window.location.href = "/#/CustomerDetail?id=2";
          break;
        case 3:
          window.location.href = "/#/CustomerDetail?id=6";
          break;
      }
    }
  }
};
</script>

<style scoped lang="less">
@gray-35383D: #35383d;
@gray-A2A4A8: #a2a4a8;
@fs56: 56px;
@fs20: 20px;
@fs40: 40px;
@white: #fff;
@blue: #3ca0dc;
@gray-lighter: #eee;
@font-rate: 28px;
@gray-dark: #999;
@font-icon-title: 40px;
@gray-light: #dddddd;
@gray-darker: #666;

@import "../../node_modules/swiper/dist/css/swiper.css";
p {
  margin: 0;
}
a:hover {
  text-decoration: none;
}
.part3-con {
  min-width: 1300px;
  background: url("../img/index/our-service.png") 100% 100%;
  background-size: cover;
}
.block {
  width: 100%;
  min-width: 1300px;
  position: relative;
  transition: all 0.25s linear 0s;

  &.part1 {
    .part1-text {
      position: absolute;
      top: 30%;
      width: 100%;
      .p1 {
        font-size: 72px;
      }
      .p2 {
        font-size: 64px;
      }
      img {
        margin-top: 35px;
      }
    }
  }

  &.part2 {
    width: 70%;
    margin: 0 auto;
    height: 713px;
    background: #fff;
    padding: 81px 0 96px;

    .title {
      color: @gray-35383D;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .p2 {
      width: 425px;
      color: @gray-A2A4A8;
      margin-bottom: 41px;
      line-height: 26px;
    }
    .p3 {
      width: 521px;
      color: @gray-A2A4A8;
      line-height: 26px;
    }

    .part2-text {
      position: absolute;
      bottom: 96px;
      width: 74%;
      min-width: 855px;
      padding-left: 50px;
      height: 177px;
      background: #fff;
      padding-top: 34px;
      box-shadow: 0 8px 30px 2px #eee;

      .biggest {
        font-size: @fs56;
        margin-bottom: 0;
      }
      .bigger {
        font-size: 33px;
        vertical-align: 4px;
      }
      .subtitle {
        color: #737679;
        padding-left: 10px;
      }
    }
  }

  &.part3 {
    min-height: 401px;
    width: 70%;
    margin: 0 auto;
    padding: 81px 0 96px;
    .part3-text {
      color: #fff;
      .title {
        font-size: @fs56;
        margin-bottom: 0;
      }
      .subtitle {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 48px;
      }
      .desc {
        margin-bottom: 16px;
        width: 1200px;
        .s-title {
          font-size: 28px;
        }
        .s-desc {
          margin-left: 41px;
          font-size: @fs20;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  &.part4 {
    margin: 0 auto;
    height: 650px;
    background: #f7f7f7;
    padding-top: 80px;
    .title {
      color: @gray-35383D;
      font-size: @fs40;
    }
    .subtitle {
      color: @gray-A2A4A8;
      width: 540px;
      margin: 8px auto 57px;
      line-height: 28px;
    }
    .cakes {
      width: 1150px;
      margin: 0 auto;
      .cake {
        flex: none;
        width: 23%;
        height: 314px;
        background: #fff;
        padding: 48px 31px;
        margin: 0 10px;

        .cake-desc {
          margin-top: 47px;
          color: @gray-35383D;
          .main-desc {
            font-size: @fs20;
            margin-bottom: 15px;
            font-weight: bold;
          }
        }
      }
    }
  }

  &.part5 {
    max-height: 578px;
    background: #fff;
    overflow: hidden;

    .mask {
      height: 100%;
      position: absolute;
      z-index: 999;
      width: 100%;
      background: rgba(53, 56, 61, 0.7);

      .arrow {
        position: absolute;
        top: 50%;
        width: 60px;
        height: 90px;
        z-index: 9;
        color: #fff;
        font-size: @fs40;
        text-align: center;
        line-height: 90px;
        cursor: pointer;
      }
      .arrow-left {
        left: 16%;
      }
      .arrow-right {
        right: 16%;
      }

      .mask-content {
        .mask-title {
          font-size: @fs40;
          padding-top: 2%;
        }
        .mask-subtitle {
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 4%;
        }
        .mask-avatar {
          margin-bottom: 3%;
        }
        .mask-quote {
          font-size: @fs20;
          margin-bottom: 16px;
        }
        .mask-desc {
          width: 451px;
          margin: 0 auto;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }

  &.part6 {
    margin: 0 auto;
    height: 751px;
    background: #f7f7f7;
    padding-top: 80px;
    .title {
      color: @gray-35383D;
      font-size: @fs40;
      margin: 8px auto 57px;
    }
    .cakes {
      width: 1150px;
      margin: 0 auto;

      .news-pic {
        width: 351px;
        height: 416px;
        background: url("../img/index/news-cover.png") no-repeat center center;
        position: relative;
        color: #fff;
        background-size: cover;
        .pic-tag {
          position: absolute;
          right: 0;
          background: #01a494;
          width: 57px;
          font-size: 14px;
          height: 37px;
          line-height: 37px;
          border-radius: 19px 0 0 19px;
        }
        .pic-shadow {
          position: absolute;
          height: 130px;
          bottom: 0;
          background: rgba(1, 164, 148, 0.7);
          padding: 26px 18px 0;
          text-align: left;
          .pic-title {
            font-size: @fs20;
            margin-bottom: 5px;
          }
          .pic-cont {
            opacity: 0.7;
          }
        }
      }
      .news-title {
        font-size: @fs20;
        text-align: left;
        margin-bottom: 8px;
        font-weight: bold;
      }
      .news-text {
        color: @gray-A2A4A8;
        text-align: left;
      }
      .divide-line {
        width: 38px;
        margin-bottom: 30px;
      }
      .divide-line,
      .news-title {
        color: @gray-35383D;
      }
    }
  }
}

.right-banner {
  width: 50px;
  min-height: 100px;
  position: fixed;
  bottom: 155px;
  right: 30px;
  z-index: 10001;
  .right-icon {
    width: 45px;
    height: 45px;
  }
  li {
    width: 100%;
    height: 50px;
    background: @white;
    border: 1px solid @gray-lighter;
    border-top: 0;
    cursor: pointer;
    position: relative;
    display: table;

    &:hover {
      background-color: #01a494;
      .icon-font {
        display: none;
      }
      .words {
        color: #fff;
        display: block;
      }
      img {
        display: block;
      }
    }
    &.fanhui-li {
      border-top: 1px solid @gray-lighter;
      border-bottom: 0;
    }
    &.contact-way {
      border-top: 1px solid @gray-lighter;
    }
    .icon-font {
      font-size: @font-rate;
      margin-top: 8px;
      color: @gray-dark;
    }
    .words {
      color: #000;
      line-height: 1.2;
      padding-top: 6px;
      display: table-cell;
      font-size: 15px;

      &.top {
        padding-top: 0;
        line-height: 45px;
      }
    }
    img {
      position: absolute;
      right: 45px;
      top: 0;
      display: none;
      width: 150px;
    }
    &.fanhui-li {
      display: none;
      .icon-font {
        font-size: @font-icon-title;
        margin-top: 2px;
      }
    }
    &.contact-way {
      .contact-info {
        display: none;
        width: 155px;
        position: absolute;
        top: 0;
        right: 45px;
        padding: 15px;
        *padding: 12px;
        background-color: @white;
        border: 1px solid @gray-light;
        p {
          color: @gray-dark;
        }
        h4 {
          color: @gray-darker;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue